<nav class="navbar navbar-inverse hidden-md-down">

  <a class="nav-link" (click)="goToSynthesis()"><i class="fa fa-list-ul" aria-hidden="true"></i> Synthèse
  </a>
  <a class="nav-link" (click)="goToTimeline()"><i class="fa fa-line-chart" aria-hidden="true"></i> Timeline
  </a>
</nav>

